import { useEffect } from 'react'
import { tagListeners } from 'features/tags/listeners'
import { startAppListening } from 'app/store'

export const useRtkListener = () => {
    useEffect(() => {
        const subscriptions = [tagListeners(startAppListening)]
        return () => subscriptions.forEach(unsubscribe => unsubscribe())
    }, [])
}
